export default __webpack_public_path__ + "static/media/alert-circle.26282881.svg";